class CombookBindingCover {
  organizationId: number;
  kidId: number;
  startDate: string; // dataLayerでkarteに開始日を送ることにのみ使用
  year: number;
  startMonth: number;
  endMonth: number;
  isIncludePhotos: boolean;
  organizationName: string;
  kidName: string;
  mimeType: string;
  designType: string;
  kidFullName: string;
  thumbnailUrl: string;

  constructor(data: {
    organizationId: number;
    kidId: number;
    startDate: string;
    year: number;
    startMonth: number;
    endMonth: number;
    isIncludePhotos: boolean;
    organizationName: string;
    kidName: string;
    mimeType: string;
    designType: string;
    kidFullName: string;
    thumbnailUrl: string;
  }) {
    this.organizationId = data.organizationId;
    this.kidId = data.kidId;
    this.startDate = data.startDate;
    this.year = data.year;
    this.startMonth = data.startMonth;
    this.endMonth = data.endMonth;
    this.isIncludePhotos = data.isIncludePhotos;
    this.organizationName = data.organizationName;
    this.kidName = data.kidName;
    this.mimeType = data.mimeType;
    this.designType = data.designType;
    this.kidFullName = data.kidFullName;
    this.thumbnailUrl = data.thumbnailUrl;
  }

  get targetPeriodText(): string {
    let text = `${this.year}年 ${this.startMonth}月〜${this.endMonth}月`;
    if (!this.isIncludePhotos) {
      text += "（写真なし）";
    }
    return text;
  }
}

export default CombookBindingCover;
